"use strict"; // https://html.spec.whatwg.org/multipage/obsolete.html#dom-external

var _classCallCheck = require("/tmp/build_9f461b9a/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/tmp/build_9f461b9a/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

exports.implementation =
/*#__PURE__*/
function () {
  function ExternalImpl() {
    _classCallCheck(this, ExternalImpl);
  }

  _createClass(ExternalImpl, [{
    key: "AddSearchProvider",
    // The AddSearchProvider() and IsSearchProviderInstalled() methods must do nothing
    value: function AddSearchProvider() {}
  }, {
    key: "IsSearchProviderInstalled",
    value: function IsSearchProviderInstalled() {}
  }]);

  return ExternalImpl;
}();